var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0607 7.93934C21.4749 7.35355 20.5251 7.35355 19.9393 7.93934C19.3536 8.52513 19.3536 9.47487 19.9393 10.0607L26.3787 16.5H6C5.17157 16.5 4.5 17.1716 4.5 18C4.5 18.8284 5.17157 19.5 6 19.5H26.3787L19.9393 25.9393C19.3536 26.5251 19.3536 27.4749 19.9393 28.0607C20.5251 28.6464 21.4749 28.6464 22.0607 28.0607L31.0607 19.0607C31.6464 18.4749 31.6464 17.5251 31.0607 16.9393L22.0607 7.93934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3041630da0d4a09caf64faaa8ce2e3d0.svg";
export { ForwardRef as ReactComponent };